import Loading from '@/shared/components/Carregando';
import { Form } from 'react-router-dom';
import { GetSetoresByUnidade } from '../setor/setor.service';
import { Modal, Button } from 'react-bootstrap';
import { CreateSetorDto, ReadSetorDto } from '@/api.types';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';

interface parametros {
  unidadeId: number;
  updateRegistros: (lista: ReadSetorDto[]) => void;
}

export default function SetoresDaUnidade({
  updateRegistros,
  unidadeId,
}: parametros) {
  const [setores, setSetores] = useState<ReadSetorDto[]>([]);

  const [loaded, setLoaded] = useState(false);
  const [modalEditar, setModalEditar] = useState(false);

  const [sigla, setSigla] = useState<string>('');
  const [capacidade, setCapacidade] = useState<number>(0);
  const [nome, setNome] = useState<string>('');

  useEffect(() => {
    if (unidadeId > 0) {
      GetSetoresByUnidade(unidadeId)
        .then((res) => {
          setSetores(res.objects);
          setLoaded(true);
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
    } else setLoaded(true);
  }, [unidadeId]);

  const handleShow = (rowData: ReadSetorDto | null) => {
    if (rowData) {
      setSigla(rowData.sigla);
      setCapacidade(rowData.capacidade);
      setNome(rowData.nome);
    } else {
      setSigla('');
      setCapacidade(0);
      setNome('');
    }
    setModalEditar(true);
  };

  function removerRegistro(sigla: string | undefined) {
    const novosSetores = setores.filter((item) => item.sigla !== sigla);
    setSetores(novosSetores);
    updateRegistros(novosSetores);
  }

  function salvarRegistro() {
    const jaExiste = setores.findIndex((item) => item.sigla == sigla);

    if (jaExiste >= 0) {
      setores[jaExiste].capacidade = capacidade;
      setores[jaExiste].nome = nome;
    } else {
      const objeto: CreateSetorDto = {
        capacidade: capacidade!,
        nome: nome,
        sigla: sigla,
        agrupar: false,
        predio: { id: unidadeId },
      };
      setores.push(objeto as unknown as ReadSetorDto);
    }
    updateRegistros(setores);
    setModalEditar(false);
  }

  if (!loaded)
    return <Loading />;

  return (
    <>
      <div className="card">
        <div className="card-header">
          <button
            type="button"
            className="btn btn-sm btn-outline-primary float-start"
            onClick={() => handleShow(null)}
          >
            Adicionar Setor
          </button>
          <h5 className="text-center">Setores</h5>
        </div>
        <div className="card-body">
          <table className="table table-sm table-bordered table-hover table-striped">
            <thead>
              <tr>
                <th className="text-center">Sigla/Numero</th>
                <th>Nome</th>
                <th className="text-center">Capacidade</th>
                <th className="text-center">Pessoas Vinculadas</th>
                <th className="text-center">Ações</th>
              </tr>
            </thead>
            <tbody>
              {setores && setores.map((setor, index) => (
                <tr key={index}>
                  <td className="text-center">{setor.sigla}</td>
                  <td>{setor.nome}</td>
                  <td className="text-center">{setor.capacidade}</td>
                  <td className="text-center">-</td>
                  <td className="text-center">
                    <button type="button" className="btn btn-outline-info btn-sm me-2" onClick={() => handleShow(setor)} >
                      Editar
                    </button>
                    <button type="button" className="btn btn-outline-danger btn-sm" onClick={() => removerRegistro(setor.sigla)} >
                      Excluir
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal show={modalEditar} onHide={() => setModalEditar(false)} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Setor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="row">
            <div className="col-md-2 mb-3">
              <label htmlFor="sigla">Sigla/Número: </label>
              <input
                id="sigla"
                type="text"
                maxLength={7}
                title="Sigla ou número do setor/sala"
                className="form-control"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setSigla(e.target.value)
                }
                value={sigla}
              />
            </div>
            <div className="col-md-2 mb-3">
              <label htmlFor="capacidade">Capacidade: </label>
              <input
                id="capacidade"
                type="number"
                title="Capacidade de Pessoal"
                min={1}
                max={999}
                className="form-control"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setCapacidade(e.target.value as unknown as number)
                }
                value={capacidade}
              />
            </div>
            <div className="col-md-6 mb-3">
              <label htmlFor="nome_setor">Nome: </label>
              <input
                id="nome_setor"
                type="text"
                title="Nome do setor/sala"
                className="form-control"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setNome(e.target.value)
                }
                value={nome}
              />
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={salvarRegistro}>
            Salvar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
